import React, { useState } from "react";
import { Icon, classnames, Tooltip } from "@culturehq/components";
import { t } from "app/utils";

interface AccordionOption {
  className: string;
  content: React.ReactNode;
  onClick?: () => void;
}

interface AccordionStateOptionsProps {
  accordionOptions: AccordionOption[];
  disabled?: boolean;
}

interface AccordionProps {
  disabled: boolean;
  accordionOptions: AccordionOption[];
  isOpen: boolean;
  toggleAccordion: () => void;
  setIsOpen: (isOpen: boolean) => void;
}

const Accordion = ({
  disabled,
  accordionOptions,
  isOpen,
  toggleAccordion,
  setIsOpen
}: AccordionProps) => (
  <div className="accordion">
    <div
      className={classnames("accordion-header", { disabled })}
      onClick={toggleAccordion}
    >
      <Icon icon="folder" className={classnames({ disabled })} />
      <span className="accordion-btn">Move Story</span>
      <Icon
        className={classnames("captions-accordion", { disabled })}
        icon={isOpen ? "chevron-up" : "chevron-down"}
      />
    </div>
    {isOpen && (
      <div className="accordion-content">
        {accordionOptions?.map((accordionOption, index) => (
          <div
            key={index}
            className={accordionOption.className}
            onClick={() => {
              if (accordionOption.onClick) {
                accordionOption.onClick();
              }
              setIsOpen(false);
            }}
          >
            {accordionOption.content}
          </div>
        ))}
      </div>
    )}
  </div>
);

const AccordionStateOptions: React.FC<AccordionStateOptionsProps> = ({
  accordionOptions,
  disabled = false
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    if (disabled) return;

    setIsOpen(!isOpen);
  };

  const children = (
    <Accordion
      disabled={disabled}
      accordionOptions={accordionOptions}
      isOpen={isOpen}
      toggleAccordion={toggleAccordion}
      setIsOpen={setIsOpen}
    />
  );

  if (disabled) {
    return (
      <div className="accordion-tooltip-archived">
        <Tooltip tip={t("It is not possible to unarchive this story because the story prompt is archived. Move the story to another prompt or unarchive the prompt first.")}>
          {children}
        </Tooltip>
      </div>
    );
  }

  return children;
};

export default AccordionStateOptions;
